import { createFileRoute } from '@tanstack/react-router'

import { RoomDetailsView, roomQueryOptions } from '@/modules/rooms'

export const Route = createFileRoute('/_auth/rooms/$roomId/')({
  component: RoomDetailsView,
  loader: async ({ context, params }) =>
    context.queryClient.ensureQueryData(roomQueryOptions(params.roomId))
})
